import React from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scrolls to the top on route changes. BrowserRouter is not a data router,
 * so <ScrollRestoration /> isn't available.
 * - Skips URLs with a hash so anchor links still work.
 * - Skips POP (back/forward) so the browser restores the previous scroll.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  React.useLayoutEffect(() => {
    if (hash || navigationType === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
};

export default ScrollToTop;
